<div class="panel-wrapper">
  <div class="panel-title" [translationEditableDirective]="name">
    {{ name | translate }}
  </div>
  <div class="panel-content">
    <ng-content></ng-content>
  </div>
</div>
